(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/play/components/pacman-background.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/play/components/pacman-background.js');
"use strict";

let pacmanPositions = _.shuffle([20, 27, 39, 51, 63, 75, 87]),
  trails = [],
  interval;
function createTrail(_ref) {
  let {
    selector,
    noDelay
  } = _ref;
  selector = $(selector);
  if (selector.length) {
    let speed = 0,
      top = 0,
      delay = 0; 

    speed = Math.round(Math.random() * 20) + 20; 
    top = pacmanPositions.pop();
    delay = noDelay ? 0 : Math.round(Math.random() * 2); 

    speed = speed / (svs.core.detect.breakpoint.greaterThan('sm') ? 1 : 2);
    delay = delay * (svs.core.detect.breakpoint.greaterThan('sm') ? 1 : 2);
    const pacmanTrail = $("<div class=\"scratch-pacman\" style=\"top: ".concat(top, "vh; animation-delay: ").concat(delay, "s; animation-duration: ").concat(speed, "s\"></div>"));
    selector.append(pacmanTrail);
    pacmanTrail.on('webkitAnimationEnd oanimationend msAnimationEnd animationend', () => {
      pacmanPositions.unshift(top);
      pacmanTrail.remove();
    });
    return pacmanTrail;
  }
}
function reset() {
  pacmanPositions = _.shuffle([20, 27, 39, 51, 63, 75, 87]);
  trails.forEach(trail => {
    trail.remove();
  });
  clearInterval(interval);
}
setGlobal('svs.tickets.play.components.pacmanBackground', selector => {
  reset();
  setTimeout(() => {
    trails.push(createTrail({
      selector,
      noDelay: true
    }));
  }, 1000); 
  interval = setInterval(() => {
    if (document.querySelector('.bg-skrapspel-pacman')) {
      trails.push(createTrail({
        selector
      }));
    } else {
      reset();
    }
  }, 6000);
});

 })(window);